(() => {
  const settings = window.FCTCartSettings;
  const meta = window.FCTCartMeta || {};

  if (!settings) {
    return;
  }

  const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const sectionsToRender = () => {
    const sections = [];

    if (document.getElementById('Cart-Drawer')) {
      sections.push('cart-drawer');
    }

    if (document.getElementById('Cart')) {
      sections.push('main-cart');
    }

    if (document.getElementById('cart-drawer-toggle')) {
      sections.push('cart-bubble');
    }

    return sections;
  };

  const fetchCart = async () => {
    try {
      const response = await fetch('/cart.js', {
        cache: 'no-store',
        credentials: 'same-origin'
      });

      if (!response.ok) {
        return null;
      }

      return await response.json();
    } catch (error) {
      console.error('Failed to fetch cart', error);
      return null;
    }
  };

  const hasCollectionProduct = (items, productIds = []) => {
    if (!Array.isArray(productIds) || !productIds.length) {
      return false;
    }

    return items.some((line) => productIds.includes(line.product_id));
  };

  const hasThresholdCollectionAmountBelowLimit = (items, productIds = [], threshold = 0) => {
    if (!Array.isArray(productIds) || !productIds.length) {
      return false;
    }

    const amount = items.reduce((sum, line) => {
      if (productIds.includes(line.product_id)) {
        return sum + line.final_line_price / 100;
      }
      return sum;
    }, 0);

    return amount < threshold;
  };

  const hasBogoQualifiedItem = (items, tags = []) => {
    if (!tags || !tags.length) {
      return false;
    }

    const normalizedTags = tags.map((tag) => (tag || '').trim()).filter(Boolean);
    if (!normalizedTags.length) {
      return false;
    }

    return items.some((line) => {
      const el = document.querySelector(`[data-cart-product-id="${line.product_id}"]`);
      if (!el) {
        return false;
      }

      const tagAttr = el.getAttribute('data-cart-product-tags');
      if (!tagAttr) {
        return false;
      }

      try {
        const productTags = JSON.parse(tagAttr) || [];
        return productTags.some((tag) => normalizedTags.includes(tag));
      } catch (error) {
        console.warn('Failed to parse product tags', error);
        return false;
      }
    });
  };

  const cleanupGifts = async (cart) => {
    const updates = {};
    const total = cart.total_price / 100;

    const removeByHandle = (handle) => {
      if (!handle) {
        return;
      }

      const line = cart.items.find((item) => item.handle === handle);
      if (line) {
        updates[line.variant_id] = 0;
      }
    };

    if (settings.isGiftDiscount && total < toNumber(settings.giftDiscountAmount)) {
      removeByHandle(settings.giftDiscountProduct);
    }

    if (settings.isSecondGiftDiscount && total < toNumber(settings.secondGiftDiscountAmount)) {
      removeByHandle(settings.secondGiftDiscountProduct);
    }

    if (settings.isGiftForCollection && settings.giftForCollectionProduct) {
      if (!hasCollectionProduct(cart.items, meta.giftForCollectionProducts)) {
        removeByHandle(settings.giftForCollectionProduct);
      }

      if (settings.isSecondGiftDiscount && total < toNumber(settings.secondGiftDiscountAmount)) {
        removeByHandle(settings.secondGiftDiscountProduct);
      }
    }

    if (settings.isThresholdGiftForCollection && settings.thresholdGiftForCollectionProduct) {
      if (
        hasThresholdCollectionAmountBelowLimit(
          cart.items,
          meta.thresholdGiftForCollectionProducts,
          toNumber(settings.thresholdGiftForCollectionAmount)
        )
      ) {
        removeByHandle(settings.thresholdGiftForCollectionProduct);
      }

      if (settings.isSecondGiftDiscount && total < toNumber(settings.secondGiftDiscountAmount)) {
        removeByHandle(settings.secondGiftDiscountProduct);
      }
    }

    if (settings.isGiftBogo && settings.giftBogoProduct) {
      if (!hasBogoQualifiedItem(cart.items, meta.giftBogoTags)) {
        removeByHandle(settings.giftBogoProduct);
      }

      if (settings.isSecondGiftDiscount && total < toNumber(settings.secondGiftDiscountAmount)) {
        removeByHandle(settings.secondGiftDiscountProduct);
      }
    }

    if (!Object.keys(updates).length) {
      return;
    }

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToRender(),
          sections_url: window.location.pathname
        })
      });

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );
    } catch (error) {
      console.error('FCT cart cleanup failed', error);
    }
  };

  const handleCartChange = async (cart) => {
    const currentCart = cart || (await fetchCart());
    if (!currentCart) {
      return;
    }

    cleanupGifts(currentCart);
  };

  document.addEventListener('line-item:change:end', (event) => {
    handleCartChange(event.detail?.cart);
  });

  document.documentElement.addEventListener('cart:item-added', () => {
    handleCartChange();
  });

  document.addEventListener('DOMContentLoaded', () => {
    handleCartChange();
    initGiftBlocks();
    initRecommendedBlocks();
    observeCartDrawer();
    initMembershipUpsellButtons();
  });

  document.documentElement.addEventListener('cart:refresh', () => {
    initGiftBlocks();
    initRecommendedBlocks();
    initMembershipUpsellButtons();
  });
})();

function sectionsToRender() {
  const sections = [];
  if (document.getElementById('Cart-Drawer')) sections.push('cart-drawer');
  if (document.getElementById('cart-drawer-toggle')) sections.push('cart-bubble');
  if (document.getElementById('Cart')) sections.push('main-cart');
  return sections;
}

// Gift block dropdowns
function initGiftBlocks(root = document) {
  const blocks = root.querySelectorAll('.c-cartDrawerGift');
  blocks.forEach((block) => {
    if (block.dataset.giftInit === 'true') return;
    block.dataset.giftInit = 'true';
    setupGiftBlock(block);
  });
}

function observeCartDrawer() {
  const drawer = document.getElementById('Cart-Drawer');
  if (!drawer) return;

  const observer = new MutationObserver(() => {
    initGiftBlocks(drawer);
    initRecommendedBlocks(drawer);
    initMembershipUpsellButtons(drawer);
  });
  observer.observe(drawer, { childList: true, subtree: true });
}

function setupGiftBlock(container) {
  const dropdowns = Array.from(container.querySelectorAll('.select-dropdown'));
  const addBtn = container.querySelector('.select-add-btn');
  const giftType = container.id;
  const variants = window.giftProductVariants?.[giftType] || [];
  const availableVariants = variants.filter((variant) => variant?.available);
  const availabilityIndex = buildAvailabilityIndex(availableVariants, dropdowns.length);

  dropdowns.forEach((dd, index) => {
    const list = dd.querySelector('.select-items');
    if (list) list.classList.add('select-hide');
    if (index > 0 && dd.classList.contains('gift')) {
      dd.classList.add('disabled');
    }
    const selected = dd.querySelector('.select-selected');
    if (selected && !selected.dataset.placeholder) {
      selected.dataset.placeholder = selected.textContent.trim();
    }
  });

  const closeAll = (except) => {
    dropdowns.forEach((dd) => {
      if (dd !== except) {
        dd.querySelector('.select-items')?.classList.add('select-hide');
      }
    });
  };

  document.addEventListener('click', (event) => {
    if (!container.contains(event.target)) {
      closeAll();
    }
  });

  dropdowns.forEach((dropdown) => {
    const selected = dropdown.querySelector('.select-selected');
    const list = dropdown.querySelector('.select-items');
    if (selected && list) {
      selected.addEventListener('click', (event) => {
        event.stopPropagation();
        if (dropdown.classList.contains('disabled')) return;
        closeAll(dropdown);
        list.classList.toggle('select-hide');
      });
    }

    list?.querySelectorAll('.select-item').forEach((item) => {
      item.addEventListener('click', () => handleSelect(item, dropdown));
    });
  });

  addBtn?.addEventListener('click', async (event) => {
    event.preventDefault();
    const variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    addBtn.disabled = true;
    addBtn.classList.add('is-loading');

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionsToRender(),
          sections_url: window.location.pathname
        })
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      console.error('Failed to add gift', error);
    } finally {
      addBtn.disabled = false;
      addBtn.classList.remove('is-loading');
    }
  });

  autoSelectSingleOption();
  updateOptionAvailability();
  updateButtons();

  function handleSelect(item, dropdown) {
    const selected = dropdown.querySelector('.select-selected');
    const list = dropdown.querySelector('.select-items');
    if (!selected || !list) return;

    list.querySelectorAll('.same-as-selected').forEach((el) => el.classList.remove('same-as-selected'));
    item.classList.add('same-as-selected');

    selected.textContent = item.textContent.trim();
    selected.setAttribute('value', item.getAttribute('data-value') || '');
    selected.dataset.selected = 'true';
    list.classList.add('select-hide');

    const position = Number(dropdown.getAttribute('data-position') || 1);
    resetFollowingSelections(position);
    updateOptionAvailability();

    updateButtons();
  }

  function updateButtons() {
    const total = dropdowns.length;
    const selectedCount = dropdowns.filter((dd) => dd.querySelector('.select-selected[data-selected="true"]')).length;

    const optionButtons = Array.from(container.querySelectorAll('.select-options-btn'));
    optionButtons.forEach((btn) => {
      const pos = Number(btn.getAttribute('data-position') || 0);
      btn.style.display = selectedCount + 1 === pos ? 'block' : 'none';
    });

    if (selectedCount === total) {
      if (addBtn) {
        addBtn.style.display = 'block';
        const variantId = resolveVariantId();
        if (variantId) {
          addBtn.setAttribute('data-variant-id', variantId);
        } else {
          addBtn.removeAttribute('data-variant-id');
        }
      }
      optionButtons.forEach((btn) => (btn.style.display = 'none'));
    } else if (addBtn) {
      addBtn.style.display = 'none';
      addBtn.removeAttribute('data-variant-id');
    }
  }

  function resolveVariantId() {
    const selections = dropdowns.map((dd) => dd.querySelector('.select-selected')?.getAttribute('value'));
    if (selections.some((v) => !v)) return null;

    return availableVariants.find((variant) =>
      selections.every((value, idx) => variant[`option${idx + 1}`] === value)
    )?.id;
  }

  function autoSelectSingleOption() {
    const active = container.classList.contains('gift-active');
    const items = container.querySelectorAll('.select-item');
    const dropdown = container.querySelector('.select-dropdown');
    if (!active || items.length !== 1 || !dropdown) return;
    dropdown.querySelector('.select-items')?.classList.remove('select-hide');
    items[0].click();
  }

  function buildAvailabilityIndex(list, optionsCount) {
    const index = Array.from({ length: optionsCount + 1 }, () => new Map());
    list.forEach((variant) => {
      const options = [];
      for (let i = 1; i <= optionsCount; i += 1) {
        options.push(variant[`option${i}`]);
      }
      for (let position = 1; position <= optionsCount; position += 1) {
        const prefix = options.slice(0, position - 1).join('||');
        if (!index[position].has(prefix)) {
          index[position].set(prefix, new Set());
        }
        index[position].get(prefix).add(options[position - 1]);
      }
    });
    return index;
  }

  function resetFollowingSelections(position) {
    dropdowns.forEach((dd) => {
      const ddPosition = Number(dd.getAttribute('data-position') || 1);
      if (ddPosition <= position) return;
      resetDropdown(dd);
      dd.classList.add('disabled');
    });
  }

  function resetDropdown(dropdown) {
    const selected = dropdown.querySelector('.select-selected');
    const list = dropdown.querySelector('.select-items');
    if (list) {
      list.querySelectorAll('.same-as-selected').forEach((el) => el.classList.remove('same-as-selected'));
    }
    if (selected) {
      selected.textContent = selected.dataset.placeholder || selected.textContent;
      selected.removeAttribute('value');
      delete selected.dataset.selected;
    }
  }

  function updateOptionAvailability() {
    const selections = dropdowns.map((dd) => dd.querySelector('.select-selected')?.getAttribute('value') || '');
    dropdowns.forEach((dropdown, index) => {
      const position = index + 1;
      const prefixValues = selections.slice(0, position - 1);
      const hasPrefix = prefixValues.every(Boolean);
      const prefixKey = prefixValues.join('||');
      const allowed = availabilityIndex[position]?.get(prefixKey) || new Set();
      const list = dropdown.querySelector('.select-items');

      list?.querySelectorAll('.select-item').forEach((item) => {
        const value = item.getAttribute('data-value') || '';
        if (allowed.has(value)) {
          item.removeAttribute('disabled');
        } else {
          item.setAttribute('disabled', 'disabled');
        }
      });

      if (!hasPrefix && position > 1) {
        dropdown.classList.add('disabled');
        return;
      }

      if (allowed.size === 0) {
        dropdown.classList.add('disabled');
      } else {
        dropdown.classList.remove('disabled');
      }

      const selected = dropdown.querySelector('.select-selected');
      const selectedValue = selected?.getAttribute('value');
      if (selected && selectedValue && !allowed.has(selectedValue)) {
        resetDropdown(dropdown);
      }
    });
  }
}

// Recommended products dropdowns
function initRecommendedBlocks(root = document) {
  const blocks = root.querySelectorAll('[data-recommended-item]');
  blocks.forEach((block) => {
    if (block.dataset.recommendedInit === 'true') return;
    block.dataset.recommendedInit = 'true';
    setupRecommendedBlock(block);
  });
}

function setupRecommendedBlock(container) {
  const dropdown = container.querySelector('.select-dropdown');
  const selected = dropdown?.querySelector('.select-selected');
  const list = dropdown?.querySelector('.select-items');
  const addBtn = container.querySelector('.select-add-btn');
  const sizeBtn = container.querySelector('.select-size-btn');

  if (!dropdown || !selected || !list || !addBtn) {
    return;
  }

  const close = () => list.classList.add('select-hide');
  close();

  document.addEventListener('click', (event) => {
    if (!container.contains(event.target)) {
      close();
    }
  });

  selected.addEventListener('click', (event) => {
    event.stopPropagation();
    list.classList.toggle('select-hide');
  });

  list.querySelectorAll('.select-item').forEach((item) => {
    item.addEventListener('click', () => {
      if (item.hasAttribute('disabled')) return;
      list.querySelectorAll('.same-as-selected').forEach((el) => el.classList.remove('same-as-selected'));
      item.classList.add('same-as-selected');
      selected.textContent = item.textContent.trim();
      selected.setAttribute('value', item.getAttribute('data-value') || '');
      close();

      if (sizeBtn) sizeBtn.style.display = 'none';
      addBtn.style.display = 'inline-flex';
      addBtn.setAttribute('data-variant-id', item.getAttribute('data-value') || '');
    });
  });

  if (sizeBtn) {
    sizeBtn.addEventListener('click', (event) => {
      event.preventDefault();
      list.classList.toggle('select-hide');
    });
  }

  addBtn.addEventListener('click', async (event) => {
    event.preventDefault();
    const variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    const sellingPlanId = addBtn.getAttribute('data-selling-plan-id');

    addBtn.disabled = true;
    addBtn.classList.add('is-loading');

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              selling_plan: sellingPlanId || undefined
            }
          ],
          sections: sectionsToRender(),
          sections_url: window.location.pathname
        })
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      console.error('Failed to add recommended product', error);
    } finally {
      addBtn.disabled = false;
      addBtn.classList.remove('is-loading');
    }
  });
}

function initMembershipUpsellButtons(root = document) {
  const buttons = root.querySelectorAll('button[data-membership-add-to-cart="true"]');

  buttons.forEach((button) => {
    if (button.dataset.membershipUpsellInit === 'true') return;
    button.dataset.membershipUpsellInit = 'true';
    button.dataset.membershipOriginalText = button.dataset.membershipOriginalText || button.innerText.trim();
    button.addEventListener('click', handleMembershipUpsellClick);
  });
}

async function handleMembershipUpsellClick(event) {
  const button = event.currentTarget;
  const variantId = button.getAttribute('variant-id');
  const membershipPackId = button.getAttribute('membership-pack-id');
  const membershipSellingPlanId = button.getAttribute('membership-selling-plan-id');

  if (!variantId) {
    return;
  }

  setMembershipButtonState(button, 'loading');

  const items = [];
  const primaryItem = { id: variantId, quantity: 1 };

  if (!membershipPackId && membershipSellingPlanId) {
    primaryItem.selling_plan = membershipSellingPlanId;
  }

  items.push(primaryItem);

  if (membershipPackId) {
    const membershipPackItem = { id: membershipPackId, quantity: 1 };
    if (membershipSellingPlanId) {
      membershipPackItem.selling_plan = membershipSellingPlanId;
    }
    items.push(membershipPackItem);
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items,
        sections: sectionsToRender(),
        sections_url: window.location.pathname
      })
    });
    const parsedState = await response.json();

    if (!response.ok || parsedState?.status) {
      throw new Error(parsedState?.description || 'Unable to add membership product');
    }

    renderMembershipCartSections(parsedState);
    setMembershipButtonsState('added');

    const detail = parsedState?.items?.[0] || parsedState;
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('cart:item-added', { product: detail });
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: detail } }));
    }
  } catch (error) {
    console.error('Membership add-to-cart failed', error);
    setMembershipButtonState(button, 'idle');
  }
}

function renderMembershipCartSections(parsedState) {
  if (!parsedState?.sections) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return;
  }

  const sections = [
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' }
  ];

  sections.forEach((section) => {
    const container = document.getElementById(section.id);
    const html = parsedState.sections?.[section.section];
    if (!container || !html) return;

    const target = container.querySelector(section.selector) || container;
    target.innerHTML = getSectionInnerHTML(html, section.selector);

    if (section.id === 'Cart-Drawer') {
      container.notesToggle?.();
      container.removeProductEvent?.();
      container.classList.add('active');
      document.body.classList.add('open-cart', 'open-cc');
      container.querySelector('.product-recommendations--full')?.classList.add('active');
    }

    if (section.id === 'Cart' && typeof Cart !== 'undefined') {
      new Cart().renderContents(parsedState);
    }
  });

  initGiftBlocks();
  initMembershipUpsellButtons();
}

function setMembershipButtonState(button, state) {
  if (!button.dataset.membershipOriginalText) {
    button.dataset.membershipOriginalText = button.innerText.trim();
  }

  if (state === 'loading') {
    button.disabled = true;
    button.classList.add('is-loading');
    return;
  }

  if (state === 'added') {
    button.disabled = true;
    button.classList.remove('is-loading');
    button.innerText = 'ADDED TO CART';
    return;
  }

  button.disabled = false;
  button.classList.remove('is-loading');
  button.innerText = button.dataset.membershipOriginalText;
}

function setMembershipButtonsState(state) {
  const buttons = document.querySelectorAll('button[data-membership-add-to-cart="true"]');
  buttons.forEach((button) => setMembershipButtonState(button, state));
}

function getSectionInnerHTML(html, selector = '.shopify-section') {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
}
